module.exports = __webpack_public_path__ + "img/mecha-1.e9705f67.jpg";